import React from "react";

export default function Logo({ size = 34, showText = true }) {
  return (
    <div className="flex items-center gap-2.5 select-none">
      <div className="relative" style={{ width: size, height: size }}>
        <svg viewBox="0 0 100 100" width={size} height={size} className="logo-ring">
          <circle cx="50" cy="50" r="46" fill="none" stroke="#D4AF37" strokeWidth="3" strokeDasharray="70 220" strokeLinecap="round" />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-display font-bold text-[#D4AF37]" style={{ fontSize: size * 0.42 }}>iW</span>
        </div>
      </div>
      {showText && (
        <div className="leading-none">
          <span className="font-display text-lg font-bold text-[#F6F1E4]">iWurks360</span>
          <span className="font-display text-lg font-bold text-[#D4AF37]">DigitAL</span>
        </div>
      )}
    </div>
  );
}
